import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  decrement (event) {
    this.nudge(event.currentTarget, -1)
  }

  increment (event) {
    this.nudge(event.currentTarget, 1)
  }

  refreshDisabled (event) {
    const stepper = event.currentTarget.closest('.form-stepper')
    if (stepper) this.updateDisabledStates(stepper)
  }

  nudge (button, direction) {
    const stepper = button.closest('.form-stepper')
    if (!stepper) return
    const input = stepper.querySelector('input[type="number"]')
    const { min, max, step } = this.readBounds(stepper)

    const current = this.currentValue(input, min)
    const next = this.clamp(this.snap(current + direction * step, step), min, max)
    if (next === current) return

    input.value = this.format(next, step)
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))
    this.updateDisabledStates(stepper)
  }

  updateDisabledStates (stepper) {
    const input = stepper.querySelector('input[type="number"]')
    const decBtn = stepper.querySelector('[data-stepper-button="decrement"]')
    const incBtn = stepper.querySelector('[data-stepper-button="increment"]')
    const { min, max } = this.readBounds(stepper)
    const current = parseFloat(input.value)

    if (Number.isFinite(current)) {
      decBtn.disabled = Number.isFinite(min) && current <= min
      incBtn.disabled = Number.isFinite(max) && current >= max
    } else {
      decBtn.disabled = false
      incBtn.disabled = false
    }
  }

  readBounds (stepper) {
    const parse = (attr) => {
      const v = stepper.dataset[attr]
      return v === undefined || v === '' ? NaN : parseFloat(v)
    }
    return {
      min: parse('min'),
      max: parse('max'),
      step: parse('step') || 1
    }
  }

  currentValue (input, min) {
    const parsed = parseFloat(input.value)
    if (Number.isFinite(parsed)) return parsed
    if (Number.isFinite(min)) return min
    return 0
  }

  clamp (value, min, max) {
    if (Number.isFinite(min)) value = Math.max(value, min)
    if (Number.isFinite(max)) value = Math.min(value, max)
    return value
  }

  snap (value, step) {
    const decimals = this.stepDecimals(step)
    const factor = Math.pow(10, decimals)
    return Math.round(value * factor) / factor
  }

  format (value, step) {
    const decimals = this.stepDecimals(step)
    return decimals > 0 ? value.toFixed(decimals) : String(value)
  }

  stepDecimals (step) {
    const str = String(step)
    const dot = str.indexOf('.')
    return dot === -1 ? 0 : str.length - dot - 1
  }
}
